import React from 'react'
import PropTypes from 'prop-types'
import { Copy, Box } from '@elparking/components'

import Distance from '../../Distance'
import ChargingPointSpeed from 'commons/js/components/ChargingPointSpeed'

CharginPointMainInfo.propTypes = {
    name: PropTypes.string,
    address: PropTypes.string,
    distance: PropTypes.number,
    plugs: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        slug: PropTypes.string,
        speedChargingType: PropTypes.number,
    })),
    power: PropTypes.number,
}

function CharginPointMainInfo ({name, address, distance, plugs, power}) {
    return (
        <>
            <Copy fontWeight='book' fontSize='large' padding='4px 0 0 0' marginBottom='8px' color='gray'>
                {name}
            </Copy>
            <Box color='gray' w='100%' fontWeight='medium'>
                <Copy fontSize='small' fontWeight='regular' padding='0'>
                    {address} {'·'}<Distance fontSize='small' distance={distance} />
                </Copy>
            </Box>
            <ChargingPointSpeed maxPower={power} plugs={plugs} />
        </>
    )
}

export default CharginPointMainInfo
